import { IServiceAction, getRequest} from "redux-request-middleware";
import {IProfile} from "StateInterface";
import { DocTypes } from "userform/utils";
import { IFlagAction } from "reducers/flagTools";
import { Flags } from "reducers/flagActions";
import {gatewayUrl} from "config";
export enum Actions {
  REQUEST_PROFILE_INFO = "REQUEST_PROFILE_INFO",
  REQUEST_PROFILE = "REQUEST_PROFILE",
  REQUEST_ALL_COMPANY = "REQUEST_COMPANY",
  REQUEST_REFERENCES = "REQUEST_REFERENCES",
  REQUEST_LOAN_INFO = "REQUEST_LOAN_INFO",
  REQUEST_SAVE_LOAN_INFO = "REQUEST_SAVE_LOAN_INFO",
  REQUEST_CREATE_LOAN_APPLICATION = "REQUEST_CREATE_LOAN_APPLICATION",
  REQUEST_FETCH_BS_UPLOAD = "REQUEST_FETCH_BS_UPLOAD",
  REQUEST_FETCH_NET_BANKING = "REQUEST_FETCH_NET_BANKING",
  SAVE_PROFILE = "SAVE_PROFILE",
  SET_USER_FLAG = "SET_USER_FLAG",
  REMOVE_ALL_FLAGS = "REMOVE_ALL_FLAGS",
  CLEAR_NET_BANKING_CONTENT = "CLEAR_NET_BANKING_CONTENT",
  CLEAR_BS_UPLOAD_CONTENT = "CLEAR_BS_UPLOAD_CONTENT",
  REQUEST_SAVE_AADHAAR_INFO = "REQUEST_SAVE_AADHAAR_INFO",
  REQUEST_CREDIT_REPORT = "REQUEST_CREDIT_REPORT",
  MOVE_BACKWARD = "MOVE_BACKWARD",
  SAVE_SOURCING_CODE = "SAVE_SOURCING_CODE",
  SAVE_UTM_PARAMS = "SAVE_UTM_PARAMS",
  REFRESH_PROFILE = "REFRESH_PROFILE",
  REFRESH_USER_STATUS = "REFRESH_USER_STATUS",
  SAVE_PRODUCTS = "SAVE_PRODUCTS",
  SAVE_EDIT_MODE = "SAVE_EDIT_MODE",
  SAVE_CONFIG = "SAVE_CONFIG",
  SAVE_SEARCH = "SAVE_SEARCH",
  REQUEST_OTP = "REQUEST_OTP",
  REQUEST_VALIDATE_OTP = "REQUEST_VALIDATE_OTP",
  SET_INCOMPLETE_INFO_STATUS = "SET_INCOMPLETE_INFO_STATUS",
  CHANGE_REFRESH_PROFILE_STATUS = "CHANGE_REFRESH_PROFILE_STATUS",
  CLEAR_REQUEST_LOAN_ERROR_RESPONSE = "CLEAR_REQUEST_LOAN_ERROR_RESPONSE",
  REQUEST_SEARCH_COMPANIES = "REQUEST_SEARCH_COMPANIES",
}

export interface IAction extends IServiceAction<Actions, {}, {}, {
  docType: DocTypes,
}>, IFlagAction<Flags> {

}

export function getProfile(userId: number) {
  return (dispatch) => {
    dispatch(
      getRequest(
        Actions.REQUEST_PROFILE_INFO,
        `lam/status/${userId}`,
      ),
    );
  };
}

export function saveProfile(profile: IProfile, direction, forwardFlag?: string) {
  return { type: Actions.SAVE_PROFILE, body: profile, direction, forwardFlag};
}

export function saveSourcingCode(sourcingCode: string) {
  return { type: Actions.SAVE_SOURCING_CODE, sourcingCode };
}

export function setFlag(flag: Flags, value: boolean): IAction {
  return { type: Actions.SET_USER_FLAG, flag, value };
}

export function removeAllFlags() {
  return { type: Actions.REMOVE_ALL_FLAGS };
}

export function clearNetBankingContent() {
  return { type: Actions.CLEAR_NET_BANKING_CONTENT };
}

export function clearBsUploadContent() {
  return { type: Actions.CLEAR_BS_UPLOAD_CONTENT };
}

export function getCreditScore(userId) {
  return (dispatch) => {
    dispatch(
      getRequest(
        Actions.REQUEST_CREDIT_REPORT,
        "/corleone/credit-score",
        null,
        null,
        null,
        gatewayUrl,
      ),
    );
  };
}

export function moveBackward() {
  return { type: Actions.MOVE_BACKWARD };
}

export function saveUtmParams(utmSource: string, utmMedium: string, utmCampaign: string) {
  return {
    type: Actions.SAVE_UTM_PARAMS,
    value: {
      source: utmSource,
      medium: utmMedium,
      campaign: utmCampaign,
    },
  };
}

export function refreshProfile() {
  return { type: Actions.REFRESH_PROFILE };
}

export function changeRefreshProfileStatus(value) {
  return { type: Actions.CHANGE_REFRESH_PROFILE_STATUS, changeTo: value};
}

export function refreshUserStatus(refresh, flag) {
  return { type: Actions.REFRESH_USER_STATUS, refresh, flag };
}

export function saveProducts(products) {
  return { type: Actions.SAVE_PRODUCTS, value: products };
}

export function setEditMode(editMode: boolean) {
  return { type: Actions.SAVE_EDIT_MODE, value: editMode };
}

export function saveConfig(param, config) {
  return { type: Actions.SAVE_CONFIG, param, config };
}

export function saveSearch(search) {
  return { type: Actions.SAVE_SEARCH, search };
}

export function setIncompleteInfoStatus(status) {
  return { type: Actions.SET_INCOMPLETE_INFO_STATUS, status };
}

export function setRequestLoanErrorMessage(message: null) {
  return { type: Actions.CLEAR_REQUEST_LOAN_ERROR_RESPONSE, message };
}
